import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LOAD_SCHEDULE, LOAD_SCHEDULE_ERR, LOAD_SCHEDULE_OK } from '@store/actions';

import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ScheduleService, Period } from '@components/agenda/services/agenda.service';

@Injectable()
export class ScheduleEffects {
  loadSchedule$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_SCHEDULE),
      mergeMap(({ professionalId }) => {
        const urlParams = professionalId.split('?');
        const actualProfessionalId = urlParams[0];
        const params = new URLSearchParams(urlParams[1] || '');
        const dateFrom = params.get('dateFrom');
        const dateTo = params.get('dateTo');

        if (!dateFrom || !dateTo) {
          return this.scheduleService.getRequestOffert(professionalId).pipe(
            map((offers) => LOAD_SCHEDULE_OK({ offers })),
            catchError((err) => of(LOAD_SCHEDULE_ERR({ payload: err }))),
          );
        }

        const period: Period = { dateFrom, dateTo };
        const weeklyPeriods = this.scheduleService.getMonthlyPeriods(period);

        return this.scheduleService.getRequestOffertByPeriods(actualProfessionalId, weeklyPeriods).pipe(
          map((responses) => {
            const offers = responses.reduce((acc, curr) => {
              if (Array.isArray(curr)) {
                return [...acc, ...curr];
              }
              return [...acc, curr];
            }, []);
            return LOAD_SCHEDULE_OK({ offers });
          }),
          catchError((err) => of(LOAD_SCHEDULE_ERR({ payload: err }))),
        );
      }),
    ),
  );

  constructor(private actions$: Actions, private scheduleService: ScheduleService) {
  }
}
